/** Glyphs of the states (`StateBadge`, rule 1): the shape tells the state without colour. Same
 *  set as the rest (outline, grid 24, stroke 1.7); `Icon` merges every file. */
export const STATE_PATHS = {
  check: <path d="M5 12.6 9.6 17 19 6.4" />,
  warning: (
    <>
      <path d="M12 3.4 21.6 20.2H2.4z" />
      <path d="M12 9.8v4.2" />
      <circle cx="12" cy="17.2" r="1" fill="currentColor" stroke="none" />
    </>
  ),
  alertCircle: (
    <>
      <circle cx="12" cy="12" r="8.8" />
      <path d="M12 7.6v5" />
      <circle cx="12" cy="16.2" r="1" fill="currentColor" stroke="none" />
    </>
  ),
  info: (
    <>
      <circle cx="12" cy="12" r="8.8" />
      <path d="M12 11v5.4" />
      <circle cx="12" cy="7.8" r="1" fill="currentColor" stroke="none" />
    </>
  ),
  offline: (
    <>
      <path d="M4 4l16 16" />
      <path d="M8.4 14.8a5 5 0 0 1 4.2-1.4M5.6 11.8a9 9 0 0 1 5-2.5M15.2 9.8a9 9 0 0 1 3.2 2M2.8 8.8a13 13 0 0 1 3.6-2.4" />
      <circle cx="12" cy="18.4" r="1.4" fill="currentColor" stroke="none" />
    </>
  ),
  wrench: (
    <path d="M14.5 4.5a4 4 0 0 0-4.6 5.4L3.4 16.4l4.2 4.2 6.5-6.5a4 4 0 0 0 5.4-4.6l-2.8 2.8-2.7-.6-.6-2.7z" />
  ),
  question: (
    <>
      <circle cx="12" cy="12" r="8.8" />
      <path d="M9.6 9.4a2.4 2.4 0 1 1 3.4 2.2c-.7.4-1 .9-1 1.8" />
      <circle cx="12" cy="16.6" r="1" fill="currentColor" stroke="none" />
    </>
  ),
} as const;
